import { T } from '@/components/t'
import { RestaurantDetailContact } from '@/features/restaurants/restaurant-detail/restaurant-detail-contact/restaurant-detail-contact'
import { useRestaurantDetailContext } from '@/features/restaurants/restaurant-detail/restaurant-detail-context'
import { RestaurantDetailLocation } from '@/features/restaurants/restaurant-detail/restaurant-detail-location/restaurant-detail-location'
import { RestaurantDetailOpeningHours } from '@/features/restaurants/restaurant-detail/restaurant-detail-opening-hours/restaurant-detail-opening-hours'
import { RestaurantDetailSection } from '@/features/restaurants/restaurant-detail/restaurant-detail-section'
import { RestaurantDetailSectionId } from '@/features/restaurants/restaurant-detail/utils/restaurant-detail-helpers'

export const RestaurantDetailInfoSection = () => {
    const { restaurant } = useRestaurantDetailContext()

    if (!restaurant) return null

    return (
        <RestaurantDetailSection
            id={RestaurantDetailSectionId.INFO}
            title="restaurants.detail.info.title"
            className="mb-14"
        >
            <div className="grid grid-cols-1 md:grid-cols-3 gap-y-8 md:gap-x-12">
                {Boolean(restaurant.openingHours?.length) && (
                    <div className="flex flex-col gap-y-4">
                        <T h3 t="restaurants.detail.openingHours.title" className="text-h5" />

                        <RestaurantDetailOpeningHours styleType="static" />
                    </div>
                )}

                <div className="flex flex-col gap-y-4">
                    <T h3 t="restaurants.detail.location.title" className="text-h5" />

                    <RestaurantDetailLocation styleType="full" />
                </div>

                {Boolean(restaurant.phone) && (
                    <div className="flex flex-col gap-y-4">
                        <T h3 t="restaurants.detail.contact.title" className="text-h5" />

                        <RestaurantDetailContact />
                    </div>
                )}
            </div>
        </RestaurantDetailSection>
    )
}
